var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPolygonCorner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.7318 0.156878C51.7967 0.327796 57.4344 6.10652 57.4344 13.1773L57.4344 54.0216L0.549031 -0.912002L44.7318 0.156878Z",
    fill: "#066D0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygonCorner);
export default __webpack_public_path__ + "static/media/polygon-corner.5bf4d0db42b9b0869fd1593f0a80da3c.svg";
export { ForwardRef as ReactComponent };